{
  "setupWorkplaceStep": {
    "title": "Lassen Sie uns Ihren Arbeitsplatz einrichten!",
    "description": "Sie müssen die nächsten drei Schritte abschließen, um einen Arbeitsplatz zu erstellen",
    "pill": {
      "setupNow": "Jetzt einrichten"
    },
    "options": {
      "sso": {
        "title": "Verbinden Sie Ihr SSO",
        "description": "Richten Sie Single Sign-On ein, um den Zugriff für Ihre Organisation zu verwalten.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Verwalten"
      },
      "orgChat": {
        "title": "Verbinden Sie Ihr Organigramm",
        "description": "Importieren Sie Ihre Organisationsstruktur, um automatisierte Workflows zu ermöglichen.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Konfigurieren"
      },
      "communicationTool": {
        "title": "Kommunikationstool verbinden",
        "description": "Sammeln Sie Feedback von Mitarbeitern über die Kommunikationsplattformen Ihres Teams.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Konfigurieren"
      },
      "billing": {
        "title": "Abrechnung einrichten",
        "description": "Fügen Sie Ihre Abrechnungsinformationen hinzu und wählen Sie einen passenden Plan.",
        "tooltipTitle": "Hilfetext",
        "buttonLabel": "Konfigurieren"
      }
    }
  },
  "connectSsoStep": {
    "title": "Verbinden Sie Ihren SSO-Anbieter",
    "description": "Richten Sie Single Sign-On ein, um den Zugriff für Ihre Organisation zu verwalten",
    "backButton": "Zurück zur Einrichtung",
    "options": {
      "domain": {
        "title": "Organisationsdomain verifizieren",
        "buttonLabel": "Verifizieren"
      },
      "provider": {
        "title": "Identitätsanbieter konfigurieren",
        "buttonLabel": "Konfigurieren"
      }
    }
  },
  "connectOrgChatStep": {
    "title": "Verbinde dein Organigramm",
    "description": "Importiere deine Organisationsstruktur, um automatisierte Workflows zu ermöglichen",
    "backButton": "Zurück zur Einrichtung",
    "options": {
      "workday": { "title": "Workday", "buttonLabel": "Verbinden" },
      "bamboo": { "title": "BambooHR", "buttonLabel": "Verbinden" }
    }
  },
  "connectCommunicationToolStep": {
    "title": "Verbinden Sie Ihr Kommunikationstool",
    "description": "Alle täglichen Fragen werden über das von Ihnen verwendete Kommunikationstool gesammelt",
    "backButton": "Zurück zur Einrichtung",
    "options": {
      "slack": { "title": "Slack", "buttonLabel": "Verbinden" },
      "teams": { "title": "Microsoft Teams", "buttonLabel": "Verbinden" }
    }
  },
  "billingStep": {},
  "alertDialog": {
    "trigger": "Später einrichten",
    "title": "Möchtest du die Einrichtung überspringen?",
    "description": "Wenn du die Einrichtung überspringst, musst du deinen Arbeitsplatz später konfigurieren. Einige Funktionen sind möglicherweise erst nach der Einrichtung verfügbar.",
    "actionButton": "Einrichtung fortsetzen",
    "cancelButton": "Einrichtung überspringen"
  }
}
